// Copyright (c) 2016 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
// in compliance with the License. You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software distributed under the License
// is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
// or implied. See the License for the specific language governing permissions and limitations under
// the License.

import apiCompatibilityChecks from 'opentracing/lib/test/api_compatibility.js';
import { assert } from 'chai';
import ConstSampler from '../src/samplers/const_sampler.js';
import InMemoryReporter from '../src/reporters/in_memory_reporter.js';
import * as opentracing from 'opentracing';
import Tracer from '../src/tracer';

describe('Jaeger Tracer', () => {
  it('is compatible with opentracing', () => {
    apiCompatibilityChecks(
      () => {
        return new Tracer('test-tracer', new InMemoryReporter(), new ConstSampler(true));
      },
      { checkBaggageValues: true }
    );
  });
});
